<template>
  <div id="app">
<!--    <router-view />-->
    <router-view  @initWebSocket="initWebSocket" @websocketonmessage="websocketonmessage" @videoPlay="videoPlay"
                  @websocketonopen="websocketonopen" @websocketonerror="websocketonerror" @websocketsend="websocketsend"
                  @closeWebSocket="closeWebSocket" @websocketclose="websocketclose" ref="getWebSocketData"></router-view>



    <comp-room ref="comproomref" :sdkAppId="Number(sdkAppId)" :secretKey="secretKey" :userId="userId"
               :roomId="Number(roomId)" :cameraId="cameraId" :microphoneId="microphoneId"></comp-room>
    <div class="rct_colse_btn" @click="colseVideo" id="colseVideo">
      <i>×</i>
    </div>

    <div class="ing" id="ing">
      <div class="ing_centent">
        <span style>正在呼叫...</span>
        <div class="colse_ing" @click="colseVideoIng" id="colseVideoIng">
          <i>×</i>
        </div>
      </div>
    </div>

  </div>
</template>
<script>

import rtc from "@/components/audioVideo/mixins/rtc.js";
import compRoom from "@/components/audioVideo/comp-room.vue";
import {getExpertInfoByLoginUser} from "@/utils/api/login";

export default {
  name:'app',
  mixins: [rtc],
  data(){
    return{
      userInfo:{},
      isLogin:false,
      token:'',
      isExpert:false,
      // userId:''

      //视频
      sysId: "",
      sdkAppId: 1400825055,
      secretKey: "d1eb737050f3a908f1ad1600c95ad64e2d9db47cf00f6214981419992dab62ad",
      isOnline: false,
      isPlay: false,
      userId: "",
      roomId: 0,
      cameraId: "",
      microphoneId: "",
      myExpertId:'',

      exportId:'',
      line_type:'',

      closetoUser:''
    }
  },
  components: {
    compRoom  //视频
  },
  created(){
    //在页面加载时读取localStorage里的状态信息
    if (localStorage.getItem("store")) {
        this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(localStorage.getItem("store"))))
    }

   if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"))//线上
      this.$store.commit('UPDATE_USERINFO',this.userInfo)
    }else{
      this.$store.commit('UPDATE_USERINFO',{})//线上
      // this.$store.commit('UPDATE_USERINFO',this.userInfo)//本地模拟用户信息
    }
    if (localStorage.getItem("isLogin")) {
      this.isLogin = localStorage.getItem("isLogin")//线上
      this.$store.commit('UPDATE_IsLogin',this.isLogin)
    }else{
      this.$store.commit('UPDATE_IsLogin',false)//线上
      // this.$store.commit('UPDATE_IsLogin',this.isLogin)//本地模拟用户信息
    }

    if (localStorage.getItem("isExpert")) {
      this.isExpert = localStorage.getItem("isExpert")//线上
      this.$store.commit('UPDATE_ISEXPERT',this.isExpert)
    }else{
      this.$store.commit('UPDATE_ISEXPERT',false)//线上
      // this.$store.commit('UPDATE_ISEXPERT',this.isExpert)//本地模拟用户信息
    }

    if (localStorage.getItem("token")) {
      this.token = localStorage.getItem("token")//线上
      this.$store.commit('UPDATE_TOKEN',this.token)
    }else{
      this.$store.commit('UPDATE_TOKEN','')//线上
      // this.$store.commit('UPDATE_TOKEN',this.token)//本地模拟用户信息
    }
    //在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener("beforeunload",()=>{
        localStorage.setItem("store",JSON.stringify(this.$store.state))
        localStorage.setItem("userInfo",JSON.stringify(JSON.parse(this.$store.state.userInfo)))
        localStorage.setItem("isLogin",this.$store.state.isLogin)
        localStorage.setItem("token",this.$store.state.token)
        localStorage.setItem("isExpert",this.$store.state.isExpert)
    })
  },

  mounted(){
    if (JSON.parse(this.$store.state.isLogin)) {
      this.userId = this.$store.state.userInfo.userId.toString();
    }
    this.getExpertInfoByLoginUser()
    //视频
    this.initWebSocket();
    document.getElementById("colseVideo").style.display = "none";
    // document.getElementById("colseVideoYY").style.display = "none";
    document.getElementById("ing").style.display = "none";
    document.getElementById("app").style.overflow= "initial";
  },

  methods:{
    //正在呼叫弹窗关闭
    colseVideoIng() {
      document.getElementById("ing").style.display = "none";
      document.getElementById("app").style.overflow= "initial";
    },
    // 专家账号获取id
    async getExpertInfoByLoginUser(){
      if(this.$store.state.isExpert=='true'){
        let params = {
          userId: this.$store.state.userInfo.userId.toString()
        }
        let res = await getExpertInfoByLoginUser(params);
        this.myExpertId = res.data.data.expertId
      } else {
        this.myExpertId = this.$store.state.userInfo.userId
      }
      // console.log('专家账号获取id--------   this.myExpertId',this.myExpertId)
    },

    initWebSocket() {
      // if (!this.userId) {
      //   alert(this.$t("先输入id"));
      //   return;
      // }
      const wsuri = this.videoWebsocketUrL+`webSocket/${this.myExpertId}`;
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      this.isOnline = true;
    },
    //  连接建立失败重连
    websocketonerror() {
      this.initWebSocket();
    },
    //视频通话
    videoPlay() {
      this.exportId  = this.$refs.getWebSocketData.getData().exportId
      this.line_type  = this.$refs.getWebSocketData.getData().line_type

      document.getElementById("ing").style.display = "block";
      document.getElementById("app").style.overflow= "hidden";
      if (this.exportId) {
        // 生成房间id
        this.roomId = parseInt(Math.random() * 100000, 10);
        // 向专家发送websocket 视频请求
        let sendMsg = {};
        if (this.line_type == "5") {
          sendMsg = {
            content: "视频请求",
            from_user: this.myExpertId.toString(),
            to_user: this.exportId.toString(),
            // from_user: '1',
            // to_user: '764025243edc445195eb8ddc4dc6a812',
            line_type: this.line_type,
            room_id: this.roomId.toString(),
            type: "0",
            from_user_name: this.$store.state.userInfo.userAccount
          };
        }
        // console.log(sendMsg);
        this.websocketsend(JSON.stringify(sendMsg));
      } else if (!this.exportId) {
        // console.log(this.$t("输入要视频的专家id"));
        return;
      }
    },

    //视频接听
    websocketonmessage(e) {
      // console.log("进入websocket", this.isPlay);
      //  数据接收
      var sd = e.data;
      console.log("e.data", e.data);
      if (e.data == "用户不在线!" || e.data == "您呼叫的用户正在通话中") {
        if (e.data == "您呼叫的用户正在通话中") {
          alert("您呼叫的用户正在通话中");
          document.getElementById("ing").style.display = "none";
          document.getElementById("app").style.overflow= "initial";
        } else if (e.data == "用户不在线!") {
          alert("用户不在线!");
          document.getElementById("ing").style.display = "none";
          document.getElementById("app").style.overflow= "initial";
        }
      } else {
        const redata = JSON.parse(sd);
        console.log("看这里", redata);
        if (redata.content == "挂断") {
          this.$refs.comproomref.handleLeave();
          this.isPlay = false;
          // document.getElementById("localStream").style.display = "none";
          // this.$refs.comproomref.noneLocalStream();
          document.getElementById("colseVideo").style.display = "none";
          document.getElementById("ing").style.display = "none";
          document.getElementById("app").style.overflow= "initial";
        }
        this.roomId = parseInt(redata.room_id);
        this.closetoUser = redata.from_user.toString()
        if (redata.content == "视频请求") {
          this.$confirm(`用户请求连接视频通话, 是否同意?`, "提示", {
            confirmButtonText: "同意",
            cancelButtonText: "拒绝",
            type: "info"
          }).then(() => {
            const sendMsg = {
              content: "同意连接",
              from_user: this.myExpertId.toString(),
              // from_user: '764025243edc445195eb8ddc4dc6a812',
              to_user: redata.from_user.toString(),
              // to_user: '1',
              line_type: redata.line_type,
              room_id: redata.room_id,
              type: "1",
              // from_user_name: this.$store.state.userInfo.userAccount
            };
            this.websocketsend(JSON.stringify(sendMsg));
            document.getElementById("ing").style.display = "none";
            document.getElementById("app").style.overflow= "initial";
            this.$refs.comproomref.handleJoinRoom();
            setTimeout(() => {
              document.getElementById("colseVideo").style.display = "block";
            }, 3000);
            this.isPlay = true;
          })
              .catch(() => {
                const sendMsg = {
                  content: "拒绝视频",
                  from_user: this.myExpertId.toString(),
                  to_user: redata.from_user.toString(),
                  line_type: redata.line_type,
                  room_id: redata.room_id,
                  type: "3",
                  from_user_name: this.$store.state.userInfo.userAccount
                };
                document.getElementById("ing").style.display = "none";
                document.getElementById("app").style.overflow= "initial";
                this.websocketsend(JSON.stringify(sendMsg));
              });
        }
        //  数据接收
        const redataJS = JSON.parse(e.data);

        // 判断房间号是否一致
        if (this.roomId == parseInt(redataJS.room_id)) {
          if (redataJS.content == "拒绝视频") {
            // alert(this.$t("已拒绝！"));
            document.getElementById("ing").style.display = "none";
          } else if (redataJS.content == "同意连接") {
            document.getElementById("ing").style.display = "none";

            if (redata.line_type == "5") {
              // 进入房间
              this.$nextTick(() => {
                this.$refs.comproomref.handleJoinRoom();
              });
              setTimeout(() => {
                document.getElementById("colseVideo").style.display = "block";
              }, 3000);
            } else {
              // 进入房间
              this.$nextTick(() => {
                this.$refs.comproomref.handleJoinRoomYY();
              });
              setTimeout(() => {

              }, 3000);
            }
          }
        }
      }
    },

    //  数据发送
    websocketsend(Data) {
      this.websock.send(Data);
    },
    //视频下线
    closeWebSocket() {
      this.websock.close();
      this.isOnline = false;
    },

    //  关闭
    websocketclose(e) {
      console.log("断开连接", e);
    },
    closeRoom() {
      this.$refs.comproomref.handleLeave();
      this.isPlay = false;
    },
    colseVideo() {
      // this.line_type  = this.$refs.getWebSocketData.getData().line_type
      this.$refs.comproomref.handleLeave();
      this.isPlay = false;
      // this.websock.close();
      // document.getElementById("localStream").style.display = "none";
      // this.$refs.comproomref.noneLocalStream();
      document.getElementById("colseVideo").style.display = "none";
      const sendMsg = {
        content: "挂断",
        from_user: this.myExpertId.toString(),
        to_user: this.closetoUser,
        line_type: "5",
        room_id: this.roomId.toString(),
        type: "2",
        from_user_name: this.$store.state.userInfo.userAccount
      };
      this.websocketsend(JSON.stringify(sendMsg));
    },
  }

};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-family: "Microsoft YaHei";
}

html body {
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
}

#app {
  width: 100%;
  height: 100%;
  // color: #fff;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #6baf6f !important;
  border-color: #6baf6f  !important;
}
.el-checkbox__inner:hover {
  border-color: #6baf6f !important;
}
</style>
<style lang="scss" scoped>
.ing {
  position: absolute;
  top: 0px;
  left: 0px;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  text-align: center;
  display: none;

  .ing_centent {
    width: 260px;
    height: 260px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -130px;
    margin-left: -130px;
    background: #ffffff;
    border-radius: 6px;

    span {
      margin-top: 19%;
      display: block;
      color: #000;
      font-size: 20px;
    }

    .colse_ing {
      width: 50px;
      height: 50px;
      line-height: 48px;
      background-color: rgba(255, 75, 75, 0.7);
      border-radius: 50%;
      text-align: center;
      margin: 70px auto;
      cursor: pointer;

      i {
        font-style: initial;
        font-weight: lighter;
        font-size: 26px;
        color: #fff;
      }
    }
  }
}

.rtc-container {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 9;
  margin-left: -245px;
  margin-top: -370px;
}

.rct_colse_btn {
  width: 50px;
  height: 50px;
  line-height: 48px;
  background-color: rgba(255, 75, 75, 0.7);
  position: absolute;
  top: 80%;
  left: 50%;
  margin-top: -25px;
  margin-left: -25px;
  /*background: rgba(0,0,0,0.3);*/
  z-index: 9;
  border-radius: 50%;
  text-align: center;
  i {
    font-style: initial;
    font-weight: lighter;
    font-size: 26px;
    color: #fff;
  }
}

.rct_colse_btn_YY {
  width: 50px;
  height: 50px;
  background-color: rgba(255, 75, 75, 0.7);
  position: absolute;
  top: 43%;
  left: 50%;
  margin-top: -25px;
  margin-left: -25px;
  /*background: rgba(0,0,0,0.3);*/
  z-index: 9;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  line-height: 45px;
  font-size: 30px;

  i {
    font-style: initial;
  }
}
</style>
